<template>
  <svg
    id="Layer_1"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    :width="width"
    :height="height"
    viewBox="-80 0 500 150"
  >
    <defs>
      <clipPath id="clip-path">
        <rect class="cls-1" x="-23" y="-21" width="392" height="179.6"></rect>
      </clipPath>
    </defs>
    <g id="RA_2020_RGB_Stacked" data-name="RA 2020 RGB Stacked">
      <g class="cls-2">
        <polygon
          class="cls-3"
          points="199.29 61.88 51.1 61.88 62.91 73.68 199.29 61.88"
        ></polygon>
        <g class="cls-2">
          <path
            class="cls-3"
            d="M64.83,14.13v1.79a15,15,0,0,0-8.6-2.77C45.85,13.15,38,22.61,38,34.24s7.89,21.09,18.27,21.09a14.91,14.91,0,0,0,8.6-2.77v1.78H74V14.13Zm-8.6,31.52c-5.12,0-8.87-5-8.87-11.41s3.75-11.4,8.87-11.4,8.74,5,8.74,11.4-3.61,11.41-8.74,11.41"
          ></path>
          <path
            class="cls-3"
            d="M137.93,14.14V37.76c0,4.43-3,8.17-7.47,8.17S123,42.19,123,37.76V14.14h-9.13V37.76c0,9.69,6.63,17.57,16.33,17.57a14,14,0,0,0,7.75-2.48v1.5h9.13V14.14Z"
          ></path>
          <path
            class="cls-3"
            d="M223,54.35V30.72c0-4.43,3-8.17,7.48-8.17s7.47,3.74,7.47,8.17V54.35h9.13V30.72c0-9.69-6.63-17.57-16.33-17.57A14,14,0,0,0,223,15.63v-1.5h-9.13V54.35Z"
          ></path>
          <path
            class="cls-3"
            d="M11.66,54.35V38.77h6.75L30.1,54.35H42L27.92,35.55a17.32,17.32,0,0,0-10-31.44H2.12V54.35Zm0-40.7h6.23a7.79,7.79,0,1,1,0,15.57H11.66Z"
          ></path>
          <path
            class="cls-3"
            d="M171.66,44.83a5.42,5.42,0,0,1-3.06,1c-1.49,0-4.3-1.14-4.3-4.93V23.68h7.81V14.13H164.3v-10h-9.13v10h-4.83v9.55h4.83V41c0,9,6.76,14.34,13.56,14.34a18.8,18.8,0,0,0,8.93-2.53Z"
          ></path>
          <polygon
            class="cls-3"
            points="96.64 32.98 112.3 14.13 99.5 14.13 88.56 28.14 88.56 0.79 79.16 0.79 79.16 54.34 88.56 54.34 88.56 37.83 102.02 54.34 114.8 54.34 96.64 32.98"
          ></polygon>
          <path
            class="cls-3"
            d="M192.74,13.11c-10.57,0-18.14,9.29-18.14,21.13,0,12.45,9.51,21.13,19,21.13,4.82,0,11-1.65,16.17-9l-8.07-4.66c-6.23,9.19-16.62,4.53-17.82-4.66h26.29c2.25-14.45-7.09-24-17.47-24m8,15.94H184.27c1.92-9.42,14.65-10,16.43,0"
          ></path>
          <path
            class="cls-3"
            d="M1.11,133.49,18.84,85.77H26l17.72,47.72h-6.5L33,121.59H11.51l-4.19,11.9Zm12.42-17.58H31L22.2,91.45Z"
          ></path>
          <path
            class="cls-3"
            d="M60.2,134.23a15,15,0,0,1-8.53-2.54,17.52,17.52,0,0,1-6-7,24.94,24.94,0,0,1,0-20.53,17.53,17.53,0,0,1,6-7,15,15,0,0,1,8.53-2.55,14.08,14.08,0,0,1,7.7,2.13A13.57,13.57,0,0,1,73,102.45V80.38h6v53.1H73.81l-.67-7.18A13.66,13.66,0,0,1,68,132.06a14.27,14.27,0,0,1-7.78,2.17m1.12-5.83a10.68,10.68,0,0,0,6-1.76,12,12,0,0,0,4.19-4.93,18.25,18.25,0,0,0,0-14.63,12.14,12.14,0,0,0-4.19-4.9,11.23,11.23,0,0,0-12,0,12.14,12.14,0,0,0-4.19,4.9,18.25,18.25,0,0,0,0,14.63,12,12,0,0,0,4.19,4.93,10.68,10.68,0,0,0,6,1.76"
          ></path>
          <polygon
            class="cls-3"
            points="97.52 133.49 82.86 95.34 89.59 95.34 101.26 126.9 112.85 95.34 119.14 95.34 104.47 133.49 97.52 133.49"
          ></polygon>
          <path
            class="cls-3"
            d="M136.49,134.38a17.65,17.65,0,0,1-9.5-2.5,16.68,16.68,0,0,1-6.25-7,25.66,25.66,0,0,1,0-20.79A17.7,17.7,0,0,1,126.8,97a15.55,15.55,0,0,1,8.86-2.58A15.39,15.39,0,0,1,144.49,97a17.52,17.52,0,0,1,6,7.07,23.58,23.58,0,0,1,2.17,10.4V116h-28q.38,6.28,3.66,9.54a11.71,11.71,0,0,0,8.61,3.25q6.8,0,11.36-6.8l3.89,4.34a18.06,18.06,0,0,1-6.77,5.94,19.25,19.25,0,0,1-8.93,2.13m-.83-34.33a9.74,9.74,0,0,0-7.25,2.88,13.91,13.91,0,0,0-3.59,8h21.62a14.08,14.08,0,0,0-3.56-8,9.63,9.63,0,0,0-7.22-2.88"
          ></path>
          <path
            class="cls-3"
            d="M157.35,133.49V95.34h5.16l.67,7.25a14,14,0,0,1,4.26-5.83,9.7,9.7,0,0,1,6.14-2.17,10.35,10.35,0,0,1,6.73,2.47l-2.1,6a8.11,8.11,0,0,0-5.31-2.17,7.55,7.55,0,0,0-4.86,1.76,12.12,12.12,0,0,0-3.44,4.75,17,17,0,0,0-1.27,6.73v19.38Z"
          ></path>
          <path
            class="cls-3"
            d="M201.32,134.23q-11.07,0-11.07-12.86v-20.5H183.6V95.34h6.65V85.47h6v9.87h13.31v5.53H196.24v20.2q0,7.34,5.61,7.33a8.3,8.3,0,0,0,3.25-.64,15.66,15.66,0,0,0,3.41-2.05l1.71,5.83a14.58,14.58,0,0,1-8.9,2.69"
          ></path>
          <path
            class="cls-3"
            d="M218.6,89.58a4.09,4.09,0,0,1-3.1-1.31,4.32,4.32,0,0,1,0-6.06,4.33,4.33,0,0,1,6.21,0,4.35,4.35,0,0,1,0,6.06,4.11,4.11,0,0,1-3.11,1.31m-3,5.76h6v38.15h-6Z"
          ></path>
          <path
            class="cls-3"
            d="M241.12,134.38a18.77,18.77,0,0,1-8.68-2,18.12,18.12,0,0,1-6.66-5.83l3.89-4.41q4.26,6.64,11.37,6.65a10,10,0,0,0,5.68-1.38,4.47,4.47,0,0,0,2-3.93q0-4.48-6.58-6.13l-4.41-1.12a14.64,14.64,0,0,1-7.26-4,9.47,9.47,0,0,1-2.61-6.69,10,10,0,0,1,1.68-5.72,11.43,11.43,0,0,1,4.6-3.93,14.92,14.92,0,0,1,6.58-1.42,17,17,0,0,1,7.52,1.69,12.92,12.92,0,0,1,5.42,4.74l-3.74,4.49a13.78,13.78,0,0,0-4.15-4.07,9.82,9.82,0,0,0-5-1.24,8.18,8.18,0,0,0-4.93,1.42,4.43,4.43,0,0,0-1.95,3.74,4.22,4.22,0,0,0,1.49,3.37,13.5,13.5,0,0,0,5.09,2.24l4.19,1.12a15.65,15.65,0,0,1,7.52,4.23,9.85,9.85,0,0,1,2.65,6.92,10.12,10.12,0,0,1-3.74,8.15q-3.74,3.15-9.94,3.14"
          ></path>
          <path
            class="cls-3"
            d="M262.58,89.58a4.08,4.08,0,0,1-3.1-1.31,4.32,4.32,0,0,1,0-6.06,4.32,4.32,0,0,1,6.2,0,4.32,4.32,0,0,1,0,6.06,4.08,4.08,0,0,1-3.1,1.31m-3,5.76h6v38.15h-6Z"
          ></path>
          <path
            class="cls-3"
            d="M272.16,133.49V95.34h5.16l.67,7.1a14.52,14.52,0,0,1,5.12-5.75,13.31,13.31,0,0,1,7.37-2.1,12.25,12.25,0,0,1,9.87,4.34Q304,103.26,304,111.5v22h-6V111.8c0-3.7-.81-6.51-2.43-8.46a8.08,8.08,0,0,0-6.54-2.91,9.52,9.52,0,0,0-5.68,1.75,11.93,11.93,0,0,0-3.86,4.68,14.65,14.65,0,0,0-1.38,6.36v20.27Z"
          ></path>
          <path
            class="cls-3"
            d="M325.93,148.59a25.94,25.94,0,0,1-9.05-1.57,20.21,20.21,0,0,1-7.25-4.49l2.32-5.45a19.92,19.92,0,0,0,6.39,4.22,19.46,19.46,0,0,0,7.44,1.46q12.2,0,12.2-14.51v-2.77a15.46,15.46,0,0,1-5.13,5.61,13.11,13.11,0,0,1-7.52,2.25,15.06,15.06,0,0,1-8.45-2.47A17.07,17.07,0,0,1,311,124a21.94,21.94,0,0,1-2.17-9.91,22.75,22.75,0,0,1,2.13-10,17.21,17.21,0,0,1,5.87-7,14.75,14.75,0,0,1,8.52-2.55,13.81,13.81,0,0,1,7.6,2.17,14.68,14.68,0,0,1,5.19,5.53l.6-7h5.17v32.91q0,10-4.72,15.18t-13.24,5.16m.45-21a10.61,10.61,0,0,0,6.06-1.76,11.88,11.88,0,0,0,4.11-4.83,15.77,15.77,0,0,0,1.5-7,16,16,0,0,0-1.5-7.1,11.63,11.63,0,0,0-4.11-4.79,10.73,10.73,0,0,0-6.06-1.72,10.43,10.43,0,0,0-5.94,1.72,11.87,11.87,0,0,0-4.08,4.79,17.58,17.58,0,0,0,0,14.21,11.84,11.84,0,0,0,4.08,4.78,10.44,10.44,0,0,0,5.94,1.73"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'RakutenAdvertisingLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss">
.cls-1 {
  fill: none;
}
.cls-2 {
  clip-path: url(#clip-path);
}
.cls-3 {
  fill: #871e8c;
}
</style>
